<app-pcbread-crumb [data]="'Sale,FastSale'"></app-pcbread-crumb>
<app-sale-factor [isFastSale]="true"></app-sale-factor>